<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex justify-content-between pb-3"
          [ngStyle]="{'flex-direction': isMobile ? 'column' : 'row', 'align-items': isMobile ? 'flex-start' : 'center'}"
          *ngIf="!isMobile">
          <span class="">
            <h2 class="text-purple-manax m-0 title-section" [ngClass]="{'pl-3': !isMobile}">Trabajos</h2>
          </span>
          <span class="">
            <button mat-raised-button type="button" class="btn btn-outline py-1 px-3 mr-0" (click)="openTasksList()"
              style="height: 30px !important; border-radius: 6px 0px 0px 6px !important;">
              <i class="material-icons">list</i>&nbsp;<span class="d-none d-sm-inline">Listado</span>
            </button>
            <button mat-raised-button type="button" class="btn btn-outline py-1 px-3 mx-0" (click)="openTasksByVisit()"
              style="height: 30px !important; border-radius: 0px 0px 0px 0px !important;">
              <i class="material-icons">table_chart</i>&nbsp;<span class="d-none d-sm-inline">Histórico</span>
            </button>
            <button mat-raised-button type="button" class="btn btn-outline-manax py-1 px-3 ml-0"
              style="height: 30px !important; border-radius: 0px 6px 6px 0px !important;">
              <i class="material-icons">table_chart</i>&nbsp;<span class="d-none d-sm-inline">Tablero</span>
            </button>
          </span>
          <span class="">
            <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openNewTaskModal('SCHEDULED')">
              <i class="material-icons">add</i> Nuevo Trabajo
            </button>
            <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2 ml-2 mr-3">
              <i class="material-icons align-middle">play_circle</i> Tutorial
            </button>
          </span>
        </div>

        <div *ngIf="isMobile" class="pb-5">
          <div class="row d-flex align-items-center justify-content-between px-3 py-2">
            <span *ngIf="!bulkInvoicing" class="pull-left">
              <h2 class="text-purple-manax m-0 title-section">Trabajos</h2>
            </span>
            <span class="pull-right pt-1 pb-1" *ngIf="!bulkInvoicing">
              <button mat-raised-button type="button" class="btn btn-manax p-2" [matMenuTriggerFor]="menu"
                (click)="$event.stopPropagation()">
                <i class="material-icons">add</i>
              </button>
              <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2">
                <i class="material-icons align-middle">play_circle</i>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openNewTaskModal('OPEN')">
                  <span><i class="material-icons align-middle">move_to_inbox</i> Solicitud de Trabajo</span>
                </button>
                <button mat-menu-item (click)="openNewTaskModal('SCHEDULED')">
                  <span><i class="material-icons align-middle">business_center</i> Trabajo Programado</span>
                </button>
              </mat-menu>
            </span>
          </div>

          <div class="row d-flex align-items-center justify-content-center px-3 py-2">
            <span *ngIf="!bulkInvoicing" style="align-self: center !important;">
              <button mat-raised-button type="button" class="btn btn-outline py-1 px-3 mr-0" (click)="openTasksList()"
                style="height: 30px; border-radius: 6px 0px 0px 6px;">
                <i class="material-icons">list</i>&nbsp;<span>Listado</span>
              </button>
              <button mat-raised-button type="button" class="btn btn-outline-manax py-1 px-3 ml-0"
                style="height: 30px; border-radius: 0px 6px 6px 0px;">
                <i class="material-icons">table_chart</i>&nbsp;<span>Tablero</span>
              </button>
            </span>
          </div>
        </div>

        <div *ngIf="loading">
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>

        <div class="board"  *ngIf="!loading">
          <!-- <div *ngIf="loading">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div> -->
          <div class="board-columns" cdkDropListGroup>
            <ng-container *ngFor="let column of board?.columns">
              <div class="board-column p-2" style="background-color: #CCC6FA !important;">
                <div class="column-title">
                  <span class="text-purple-manax text-bold mr-2">
                    {{ column.name }}
                  </span>
                  <span class="text-default">{{column.tasks.length}}</span>
                  <span *ngIf="column.value == 'SCHEDULED'">
                    <select class="filter small pull-right" [(ngModel)]="filter.filters.scheduled"
                      (ngModelChange)="getTasks(true)" (click)="$event.stopPropagation()">
                      <option [ngValue]="'TODAY'"> solo hoy </option>
                      <option [ngValue]="'WEEK'"> hasta una semana </option>
                      <option [ngValue]="'MONTH'"> hasta un mes </option>
                      <option [ngValue]="'ALL'"> todos </option>
                    </select>
                  </span>
                  <span *ngIf="column.value == 'COMPLETED'">
                    <select class="filter small pull-right" [(ngModel)]="filter.filters.completed"
                      (ngModelChange)="getTasks(true)" (click)="$event.stopPropagation()">
                      <option [ngValue]="'TODAY'"> solo hoy </option>
                      <option [ngValue]="'WEEK'"> última semana </option>
                      <option [ngValue]="'MONTH'"> último mes </option>
                      <option [ngValue]="'ALL'"> todos </option>
                      <option [ngValue]="undefined"> ninguno </option>
                    </select>
                  </span>
                  <span *ngIf="column.value == 'INVOICED'">
                    <select class="filter small pull-right" [(ngModel)]="filter.filters.invoiced"
                      (ngModelChange)="getTasks(true)" (click)="$event.stopPropagation()">
                      <option [ngValue]="'TODAY'"> solo hoy </option>
                      <option [ngValue]="'WEEK'"> última semana </option>
                      <option [ngValue]="'MONTH'"> último mes </option>
                      <option [ngValue]="'ALL'"> todos </option>
                      <option [ngValue]="undefined"> ninguno </option>
                    </select>
                  </span>
                  <span *ngIf="column.value == 'CANCELLED'">
                    <select class="filter small pull-right" [(ngModel)]="filter.filters.cancelled"
                      (ngModelChange)="getTasks(true)" (click)="$event.stopPropagation()">
                      <option [ngValue]="'TODAY'"> solo hoy </option>
                      <option [ngValue]="'WEEK'"> última semana </option>
                      <option [ngValue]="'MONTH'"> último mes </option>
                      <option [ngValue]="'ALL'"> todos </option>
                      <option [ngValue]="undefined"> ninguno </option>
                    </select>
                  </span>
                </div>

                <div class="tasks-container" cdkDropList [id]="column.value" [cdkDropListData]="column.tasks"
                  (cdkDropListDropped)="drop($event)">

                  <!-- task card -->
                  <ng-container>
                    <!--*ngIf="showComplete || (column.value != 'COMPLETED' && column.value != 'CANCELLED')"-->
                    <div class="task" *ngFor="let item of column.tasks" cdkDrag [cdkDragDisabled]="isMobile"
                      (dblclick)="openTasksModal(item.task)">

                      <!-- menu btn -->
                      <button type="button" class="btn btn-link text-lavuro p-0 m-0 pull-right"
                        [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                        <i class="material-icons small">more_vert</i>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="openTasksModal(item.task)">
                          <span>Abrir / Modificar</span>
                        </button>
                        <button mat-menu-item (click)="openDuplicateTaskModal(item.task)">
                          <span>Duplicar</span>
                        </button>
                        <button mat-menu-item (click)="openDeleteTaskConfirm(item.task, true)" *ngIf="isDev">
                          <span>Hard Delete</span>
                        </button>
                        <button mat-menu-item (click)="openDeleteTaskConfirm(item.task)" *ngIf="!item.task.isDeleted">
                          <span>Eliminar</span>
                        </button>
                        <button mat-menu-item (click)="openRestoreTaskConfirm(item.task)" *ngIf="item.task.isDeleted">
                          <span>Restaurar</span>
                        </button>
                      </mat-menu>

                      <!-- client -->
                      <b class="text-lavuro">
                        {{item.task.client?.firstname}} {{item.task.client?.lastname}}
                      </b><br>

                      <!-- task data -->
                      <span class="text-gray">
                        {{item.task.title}}
                      </span><br>
                      <span class="small">
                        <span class="text-gray"><!-- cambio al migrar -->
                          {{item.task.category?.[0]?.name}} 
                        </span><br>
                        <span *ngIf="item.task?.scheduledStart" class="text-success">
                          <i class="material-icons inline-icon">event_note</i>
                          {{item.task.scheduledStart | date:'dd/MM/yyyy HH:mm'}} ({{item.task.duration}} hs)
                        </span>
                        <span *ngIf="!item.task?.scheduledStart" class="text-gray">
                          <i class="material-icons inline-icon">calendar_today</i>
                          {{item.task.createdAt | date:'dd/MM/yyyy'}}
                        </span>
                      </span>


                      <div class="pull-right">

                        <!-- quoted -->
                        <span class="small" *ngIf="item.task.total && item.task.total > 0">
                          {{item.task.total | money: { needSymbol:true } }}
                        </span>

                        <!-- quoted -->
                        <button type="button" class="btn btn-link text-success p-0 m-0 icons"
                          *ngIf="(item?.workers?.length > 0)" [title]="item.workers">
                          <i class="material-icons small">engineering</i>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <!-- end: task card -->

                  <!--button class="btn btn-link text-lavuro p-0 m-0 small" (click)="getTasks()"
                        *ngIf="!showComplete && (column.value == 'COMPLETED' || column.value == 'CANCELLED')">
                        <i class="material-icons small">add</i>
                        Ver completo ...
                      </button-->
                </div>
              </div>

            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>